// This module works as middleware to check an perform authentication
// towards the API
// =============================================================================
import { History } from 'history';
import { urls } from '../services/Server';

class Auth {
  apiWorking: boolean;
  listeners: Function[];

  constructor() {
    this.apiWorking = true;
    this.listeners = [];
  }

  redirect(history: History, pathname: string) {
    // Redirect to a path.
    history.replace({
      pathname
    });
  }

  login(token: string) {
    // Save the token in local storage to indicate that we are logged in
    localStorage.token = token;
  }

  logout(history: History) {
    // Remove token from localstora
    delete localStorage.token;
    // Send a logout request to the server
    fetch(urls.logout, { credentials: 'include' });
    // Notify listeners that the login state has changed
    this.onChange();
    // Redirect to home page.
    this.redirect(history, '/');
  }

  isLoggedIn() {
    // Check if we have a login token in local storage.
    return !!localStorage.token;
  }

  // Method to check if the user is logged in
  checkIfLoggedInOnServer(callback: Function) {
    // Send a request to the server and check if we are authenticated.
    fetch(urls.isAuthenticated, { credentials: 'include' })
      .then(response => response.json())
      .then(json => {
        if (json.authenticated) {
          this.login(json.token);
        } else {
          delete localStorage.token;
        }
        callback();
      })
      .catch(() => {
        this.apiWorking = false;
        delete localStorage.token;
        callback();
      });
  }

  // Notify listeners that the auth state has changed
  onChange() {
    this.listeners.forEach(func => {
      func();
    });
  }

  // Add a function that will run if the auth state changes.
  addListener(func: Function) {
    this.listeners.push(func);
  }

  // Remove the listener on the auth state
  removeListener(func: Function) {
    const index = this.listeners.indexOf(func);
    if (index > -1) {
      this.listeners.splice(index, 1);
    }
  }

  // Check if the API is up and running
  apiIsWorking() {
    return this.apiWorking;
  }
}

export default new Auth();
